import React from "react";
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import { Grid } from "@mui/material";
import "./sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from "../../container/Sidebar/Sidebar";
import { useTranslation } from "react-i18next";
import "../../Style/defaultstyle.scss";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import BanneServerApplication from "../../container/Banner/banner-serverApplication";
import DividerComponent from "../../container/Divider/divider";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";

// Titlecloudcompute
function MSA2() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "마이크로서비스 개발의 필수요소들 - Serverless Application - 프라이빗 클라우드";
    }, []);
    return (
        <div className="App">
            <NavButton
                option={{
                    // logo: logoKube,
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061ff" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            {/* {Banner(t('banner.hanbiro'), t('banner.microsoft'))} */}
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("한비로 마이크로서비스 기반 개발이란")} */}
                        <BoxContent>
                            <BoxTitle className="sub-title">
                                <p class="typo-21 typo-medium typo-black">CQRS</p>
                            </BoxTitle>

                            <BoxText
                                dangerouslySetInnerHTML={{
                                    __html: `
                            <p class='typo-14'>Command and Query Responsibility Segregation (명령과 책임분리) </p>
                            <p class='typo-14'>• 명령 : 데이터 변경 (Create, Update, Delete) 작업 </p>
                            <p class='typo-14'>• 쿼리 : 데이터 쿼리(Read)작업 </p>
                            <p class='typo-14'>• 명령과 쿼리 작업의 책임을 분리하는 것 </p>
                            `,
                                }}
                            ></BoxText>

                            <Image src="https://hanbiro.com/msa/images/cqrs.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className="sub-title">
                                <p class="typo-21 typo-medium typo-black">EventSourcing</p>
                            </BoxTitle>

                            <BoxText
                                dangerouslySetInnerHTML={{
                                    __html: `
                            <p class='typo-14'>순차적으로 발생하는 이벤트를 적용된 순서대로 모두 저장 </p>
                            <p class='typo-14'>이벤트의 갱신이나 삭제 연산은 수행되지 않음 </p>
                            <p class='typo-14'>이벤트 소싱은 확장성이 뛰어나고 분산된 변경처리 방식 </p>
                            `,
                                }}
                            ></BoxText>

                            <Image src="https://hanbiro.com/msa/images/event-source.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className="sub-title">
                                <p class="typo-21 typo-medium typo-black">API 게이트웨이</p>
                            </BoxTitle>

                            <BoxText
                                dangerouslySetInnerHTML={{
                                    __html: `
                            <p class='typo-14'>마이크로서비스는 API를 통해 통신 </p>
                            <p class='typo-14'>URL별 : a.vora.net 과 b.vora.net 를 구분해 라우팅 </p>
                            <p class='typo-14'>모듈별(Prefix별 / Host별) : a.vora.net/a 과 a.vora.net/b 를 구분해 라우팅 </p>
                            <p class='typo-14'>여러 서비스의 엔드포인트와 REST API를 관리 </p>
                            `,
                                }}
                            ></BoxText>

                            <Image src="https://hanbiro.com/msa/images/api-gateway.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className="sub-title">
                                <p class="typo-21 typo-medium typo-black">컨테이너, Docker 및 Kubernetes</p>
                            </BoxTitle>

                            <BoxText
                                dangerouslySetInnerHTML={{
                                    __html: `
                            <p class='typo-14'>쿠버네티스의 POD은 가상서버보다 작고 경량으로 마이크로서비스에 적합 </p>
                            `,
                                }}
                            ></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className="sub-title">
                                <p class="typo-21 typo-medium typo-black">서버리스(Serverless)서비스로 제공되는 API들</p>
                            </BoxTitle>

                            <BoxText
                                dangerouslySetInnerHTML={{
                                    __html: `
                            <p class='typo-14'>쿠버네티스의 POD은 가상서버보다 작고 경량으로 마이크로서비스에 적합 </p>
                            <p class='typo-14'>어플리케이션이 필요한 경우에만 시작 </p>
                            <p class='typo-14'>유휴 상태일 때는 비용부과되지 않음 (서비스에 따라 저장용량 비용 발생) </p>
                            <p class='typo-14'>개발기간과 비용단축 </p><br>

                            <div style="display: grid; grid-template-columns: auto auto;">
                                <p class='typo-14'>• Identity : OAuth</p>
                                <p class='typo-14'>• Core Storage (S3)</p>
                                <p class='typo-14'>• Directory</p>
                                <p class='typo-14'>• Simple URL Shortner</p>
                                <p class='typo-14'>• IAM (Identity and Access Management)</p>
                                <p class='typo-14'>• Generate QR Code</p>
                                <p class='typo-14'>• Event Sourcing</p>
                                <p class='typo-14'>• Business Process</p>
                                <p class='typo-14'>• Long-running</p>
                                <p class='typo-14'>• Automation Rule</p>
                                <p class='typo-14'>• Messaging :</p>
                                <p class='typo-14'>• Email</p>
                                <p class='typo-14' style="margin-left: 15px">• Topics</p>
                                <p class='typo-14'>• SMS</p>
                                <p class='typo-14' style="margin-left: 15px">• Queues</p>
                                <p class='typo-14'>• DNS</p>
                                <p class='typo-14'style="margin-left: 15px">• Incoming Webhooks</p>
                                <p class='typo-14'>• IOT</p>
                                <p class='typo-14' style="margin-left: 15px">• Outgoing Webhooks</p>
                                <p class='typo-14'>• Search query</p>
                                <p class='typo-14' style="margin-left: 15px">• Scheduler</p>
                                <p class='typo-14'>• Rate Limiting</p>
                            </div>
                            
                            `,
                                }}
                            ></BoxText>
                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            {/* <Cloudconsult /> */}
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

const BoxTitle = styled.div`
    text-align: left;
    font-weight: bold;
`;

const BoxContent = styled.div`
    ${
        "" /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */
    }
    text-align: left;
`;

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`;

const BoxSubText = styled.div`
    margin-left: 7%;
`;

const Image = styled.img`
    width: 100%;
`;

export default MSA2;
